import { render, staticRenderFns } from "./TrainingPathDashboard.vue?vue&type=template&id=56620b96&scoped=true&"
import script from "./TrainingPathDashboard.vue?vue&type=script&lang=ts&"
export * from "./TrainingPathDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPathDashboard.vue?vue&type=style&index=0&id=56620b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56620b96",
  null
  
)

/* custom blocks */
import block0 from "./TrainingPathDashboard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VProgressCircular,VRow,VSheet})
